import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../Variants/VariantsTile/messages';
import { UnavailableWrapper } from '../styled';

export const Unavailable = () => {
  return (
    <UnavailableWrapper>
      <FormattedMessage {...messages.unavailable} />
    </UnavailableWrapper>
  );
};
